import { Injectable } from '@angular/core';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { NomWebServicesJson } from "@common/services/nom-web-services-json";
import { SearchResults } from "@common/data-models/search-results/search-results";
import { ServiceResponse } from "@common/data-models/service/service-response";
import { ObjectTypes } from "@common/enums/object-types";
import { ServiceCollectionRecord } from '@common/data-models/service/service-collection-record';
import { UserRecord } from "@common/data-models/records/user-record";
import { DataStore } from "@common/data-models/data-store/data-store";

import { VisualStateService } from "@common/services/visual-state-service";

@Injectable({ providedIn: 'root' })
export class UserLocationService {
    constructor(
        public nomWebServicesJson: NomWebServicesJson,
        public visualStateService: VisualStateService
    ) {
    }

    public async getUserLocationResources(database: string, locations: Array<string>, filterQuery: string, referral: string): Promise<ServiceResponse<SearchResults>> {
        let results = new SearchResults();
        let response: HttpResponse<any> = null;
        try {
            response = await this.nomWebServicesJson.get(
                "/api/ResourceLocations",
                {
                    headers: new HttpHeaders({
                        "Content-Type": "application/json",
                        "X-ENPS-TOKEN": this.nomWebServicesJson.NomTokenId
                    }),
                    responseType: 'json',
                    params: {
                        database: database,
                        path: locations.join(';'),
                        fq: filterQuery
                    },
                    observe: 'response'
                });
            if (response) {
                let respObj = response.body;
                results.objectType = ObjectTypes.USER;
                for (let p of respObj.SearchResults) {
                    let serviceCollectionRecord: ServiceCollectionRecord = ServiceCollectionRecord.instance(p);
                    let userRecord = this.nomWebServicesJson.Convertor.fromServiceUserRecord(serviceCollectionRecord);
                    DataStore.set(userRecord);
                    let record = DataStore.byGuid<UserRecord>(userRecord.guid, referral);
                    results.addUser(record);
                }
                locations.forEach(loc => DataStore.subscribeForPathUpdates(database, loc + "RS"));
            }
        } catch (error) {
            this.nomWebServicesJson.showErrorModal({
                message: "Unable to get resource locations",
                detailMessage: `Unable to get resource locations. \n\rStackTrace: NomWebServicesJson.getUserLocationResources(); \n\rError: ${error}`
            });
            return new ServiceResponse<SearchResults>(false, "Unable to get user locations " + error.toString());
        }
        return new ServiceResponse<SearchResults>(true, results);
    }

}
